import { createEmiColumnHelper } from "components/table";

const columnHelper = createEmiColumnHelper();

const createModelTaskColumns = ({
	showOperatingMode,
	showSystem,
	customCaptions,
	modelType,
}) => {
	const definitions = [
		{ id: "logo", label: "", sortable: false, width: "110px" },
		{ id: "orderNumber", label: "Order" },
		{ id: "actionName", label: customCaptions?.actionRequired },
		{ id: "name", label: "Name" },
		...(modelType === "F"
			? [{ id: "assets", label: customCaptions?.asset }]
			: []),
		...(showOperatingMode
			? [{ id: "operatingModeName", label: customCaptions?.operatingMode }]
			: []),
		...(showSystem
			? [{ id: "systemName", label: customCaptions?.system }]
			: []),
		{ id: "roles", label: customCaptions?.rolePlural },
		{ id: "estimatedMinutes", label: "Est Mins" },
		{ id: "intervals", label: customCaptions?.intervalPlural, width: "100px" },
		{ id: "stages", label: customCaptions?.stagePlural },
		{ id: "zones", label: customCaptions?.zonePlural },
		{ id: "arrangements", label: customCaptions?.arrangementPlural },
		{ id: "notes", label: "Notes", sortable: false },
	];

	return {
		columns: definitions.map(({ id }) => id),
		columnDefs: columnHelper.columns(
			definitions.map((definition) =>
				columnHelper.accessor(definition.id, {
					header: definition.label,
					enableSorting: definition.sortable !== false,
					meta: { width: definition.width },
				})
			)
		),
	};
};

export default createModelTaskColumns;
